import axios from "axios";
import { BASE_URL_API } from "../../configs/env";
import { isEmpty } from "lodash";
import { Resolver } from "dns";
import Store from "store/index";
// Create Axios instance
const client = axios.create({
  baseURL: BASE_URL_API,
});

// Set default timeout
client.defaults.timeout = 100000;

const call = async (method: string, url: any, data: any) => {
  const { language } = Store.getState();
  const currentLanguage = language.language.name === "fa" ? "fa-IR" : "en";
  // get token
  const Authorization = localStorage.getItem("token");

  // Set default header to Axios
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "accept-language": currentLanguage,
    Authorization,
  };

  // Preparing Axios request attribute
  const request: any = { headers, method, url };
  // Set Axios method
  if (!isEmpty(data)) {
    if (method === "get") {
      request.params = data;
    } else {
      request.data = data;
    }
  }

  try {
    const response: any = await client(request);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export default {
  get: (url: string, data?: any) => call("get", url, data),
  post: (url: string, data?: any) => call("post", url, data),
};
